export class ContactModal {

    contactId : number;
    firstName: string = "";
    lastName : string = "";
    phoneNo: string = "";
    email : string = "";
    //supplier : SupplierModal;
}
